import { Role } from "./AuthContext";

export type TabKey = "authoring" | "analysis" | "automation" | "adminUsers";

// Hier zentral pflegen, welche Rolle welchen Tab sehen darf.
// Ein Tab ist sichtbar, wenn der User MINDESTENS eine der Rollen hat.
export const TAB_PERMISSIONS: Record<TabKey, Role[]> = {
  authoring: ["author","moderator", "admin"],
  automation: ["author","moderator", "admin"],
  analysis: ["author","moderator", "admin"],
  adminUsers: ["admin"],
};

export const TAB_LABELS: Record<TabKey, string> = {
  authoring: "Beitrag erstellen",
  analysis: "Marketing Analyse",
  automation: "Redaktionsplanung",
  adminUsers: "Nutzerverwaltung",
};
